import React, { useState, useEffect } from 'react';
import URLManager from '../funcionalidadeNavbar/URLManager';
import { useNavigate } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

const MovimentacaoEstoque = () => {
  const [materiasPrimas, setMateriasPrimas] = useState([]);
  const [materiaPrimaId, setMateriaPrimaId] = useState('');
  const [inputValue, setInputValue] = useState('');
  const [quantidade, setQuantidade] = useState('');
  const [mensagem, setMensagem] = useState('');
  const [loading, setLoading] = useState(false);
  const [tipoMovimentacao, setTipoMovimentacao] = useState('entrada');
  const navigate = useNavigate();

  useEffect(() => {
    // Carregar matérias-primas da API
    const fetchMateriasPrimas = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${URLManager.getBaseURL()}/materiaPrima/listar`, {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}`
          }
        });
        if (!response.ok) throw new Error('Erro ao buscar matérias-primas');
        const data = await response.json();
        setMateriasPrimas(data);
      } catch (error) {
        setMensagem(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchMateriasPrimas();
  }, []);

  const handleMovimentacao = async () => {
    if (!materiaPrimaId || !quantidade || !tipoMovimentacao) {
      setMensagem('Selecione a matéria-prima, o tipo de movimentação e informe a quantidade.');
      return;
    }
    setMensagem('');
    setLoading(true);
    try {
      const url = `${URLManager.getBaseURL()}/estoque/${tipoMovimentacao}/${materiaPrimaId}`;
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}`
        },
        body: JSON.stringify({ quantidade: parseFloat(quantidade) })
      });
      const result = await response.text();
      if (response.ok) {
        setMensagem(result || 'Movimentação registrada com sucesso!');
      } else {
        setMensagem(result || 'Erro ao registrar movimentação.');
      }
    } catch (error) {
      setMensagem('Erro de conexão com o servidor.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f4f6fa' }}>
      <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 4px 24px rgba(0,0,0,0.10)', padding: 32, minWidth: 350, maxWidth: 400 }}>
        <h2 style={{ textAlign: 'center', marginBottom: 24, color: '#2d3a4b' }}>Movimentação de Estoque</h2>
        <div style={{ marginBottom: 18 }}>
          <label style={{ fontWeight: 500, color: '#2d3a4b' }}>Matéria-prima:</label><br />
          <Autocomplete
            options={materiasPrimas}
            getOptionLabel={option => option && (option.descricao || option.nome) ? `${option.descricao || option.nome} ${option.saldoEstoque !== undefined ? `(Saldo: ${option.saldoEstoque})` : ''}` : ''}
            filterOptions={(options, state) =>
              options.filter(option =>
                (option.descricao || option.nome || '').toLowerCase().includes(state.inputValue.toLowerCase())
              )
            }
            value={materiasPrimas.find(mp => mp.id === materiaPrimaId) || null}
            onChange={(event, newValue) => {
              setMateriaPrimaId(newValue ? newValue.id : '');
            }}
            inputValue={inputValue}
            onInputChange={(event, newInputValue) => {
              setInputValue(newInputValue);
            }}
            renderInput={(params) => (
              <TextField {...params} label="Digite para buscar..." variant="outlined" size="small" autoFocus />
            )}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            noOptionsText="Nenhuma matéria-prima encontrada"
            sx={{ width: '100%', marginTop: 1 }}
            autoHighlight
            openOnFocus
            clearOnBlur={false}
          />
        </div>
        <div style={{ marginBottom: 18 }}>
          <label style={{ fontWeight: 500, color: '#2d3a4b' }}>Tipo de Movimentação:</label><br />
          <select
            value={tipoMovimentacao}
            onChange={e => setTipoMovimentacao(e.target.value)}
            style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #cfd8dc', marginTop: 4 }}
          >
            <option value="entrada">Entrada</option>
            <option value="saida">Saída</option>
            <option value="reposicao">Reposição</option>
          </select>
        </div>
        <div style={{ marginBottom: 18 }}>
          <label style={{ fontWeight: 500, color: '#2d3a4b' }}>Quantidade:</label><br />
          <input
            type="number"
            value={quantidade}
            onChange={e => setQuantidade(e.target.value)}
            min="0"
            step="any"
            style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #cfd8dc', marginTop: 4 }}
            placeholder="Informe a quantidade"
          />
        </div>
        <div style={{ marginBottom: 18 }}>
          <button
            onClick={handleMovimentacao}
            disabled={loading}
            style={{
              width: '100%',
              background: '#1976d2',
              color: '#fff',
              border: 'none',
              borderRadius: 6,
              padding: '10px 0',
              fontWeight: 600,
              cursor: loading ? 'not-allowed' : 'pointer',
            }}
          >
            {loading ? 'Processando...' : 'Registrar Movimentação'}
          </button>
        </div>
        <button
          onClick={() => navigate(-1)}
          style={{
            width: '100%',
            background: '#607d8b',
            color: '#fff',
            border: 'none',
            borderRadius: 6,
            padding: '10px 0',
            fontWeight: 600,
            cursor: 'pointer',
            marginBottom: 10
          }}
        >
          Voltar
        </button>
        {mensagem && (
          <div style={{
            marginTop: 10,
            color: mensagem.includes('sucesso') ? '#388e3c' : '#d32f2f',
            background: mensagem.includes('sucesso') ? '#e8f5e9' : '#ffebee',
            borderRadius: 6,
            padding: 10,
            textAlign: 'center',
            fontWeight: 500
          }}>
            {mensagem}
          </div>
        )}
      </div>
    </div>
  );
};

export default MovimentacaoEstoque;
